import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { Tooltip as Tooltip$1 } from '@cheetahdigital/console-kit-cx';
import classNames from '../../../node_modules/classnames/index.js';
import { Popup } from 'semantic-ui-react';
import styles from './index.module.scss.js';

var Tooltip = function (_a) {
    var isCk = _a.isCk, content = _a.content, children = _a.children, _b = _a.position, position = _b === void 0 ? "right center" : _b, _c = _a.isInline, isInline = _c === void 0 ? false : _c, isDisabled = _a.isDisabled, isGapless = _a.isGapless, isBreakAll = _a.isBreakAll, color = _a.color, icon = _a.icon, isEllipsis = _a.isEllipsis, className = _a.className, isWide = _a.isWide;
    var popupStyle = {
        borderRadius: "2px",
        padding: ".625rem 2rem",
        background: "#ffffff",
        fontSize: "1.1rem",
        color: "#505959",
        lineHeight: "1.5rem",
        boxShadow: "0 0.8rem 2rem 0 rgba(57, 66, 66, 0.5)"
    };
    var triggerStyle = {
        display: isInline ? "inline-flex" : "block",
        padding: isGapless ? "none" : ".25rem"
    };
    if (!content) {
        return jsx(Fragment, { children: children }, void 0);
    }
    return (jsxs(Fragment, { children: [!isCk && (jsx(Popup, { wide: isWide, content: content, trigger: jsxs("div", __assign({ style: triggerStyle }, { children: [isEllipsis && (jsxs("div", __assign({ className: styles.tooltipContent }, { children: [icon && jsx(Fragment, { children: icon }, void 0), jsx("div", __assign({ className: classNames(isEllipsis && styles.isEllipsis) }, { children: children }), void 0)] }), void 0)), !isEllipsis && children] }), void 0), style: popupStyle, className: classNames(styles.popup, "ck-popup-menu-parent", isBreakAll && styles.isBreakAll, className), disabled: isDisabled, position: position }, void 0)), isCk && (jsx(Tooltip$1, __assign({ color: color, tooltip: content, position: position, isInline: false, isCompact: true, isMultiLine: true }, { children: children }), void 0))] }, void 0));
};

export { Tooltip as default };
